import { itemStorage } from './storageHelpers';

export const accessToken = itemStorage('accessToken');
export const refreshToken = itemStorage('refreshToken');
